/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var IndividualEstimateRequest;
(function (IndividualEstimateRequest) {
    /**
     * How is the car powered?
     */
    let car_fuel_type;
    (function (car_fuel_type) {
        car_fuel_type["GASOLINE"] = "gasoline";
        car_fuel_type["ELECTRIC"] = "electric";
        car_fuel_type["HYBRID"] = "hybrid";
    })(car_fuel_type = IndividualEstimateRequest.car_fuel_type || (IndividualEstimateRequest.car_fuel_type = {}));
})(IndividualEstimateRequest || (IndividualEstimateRequest = {}));
//# sourceMappingURL=IndividualEstimateRequest.js.map